export default __webpack_public_path__ + "dist/media/Cross-blue.067d5e4d.svg";